import './TrackingModal.scss';

import {
  Button,
  Modal,
  ModalBody,
  ToggleButton,
  ToggleButtonGroup
} from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { BsArrowLeft } from 'react-icons/bs';
import Cookies from 'js-cookie';
import message from './cookiesMessages';
import { useIntl } from 'react-intl';
import { useToggle } from 'react-use';

interface Props {
  open: boolean;
  onClose: () => void;
}

const TrackingModal = (props: Props) => {
  const cookiesExpirationDay = 182;

  const intl = useIntl();
  const [showModal, toggleModal] = useToggle(false);
  const [settingsToggle, toggleSettings] = useToggle(false);

  const [privacyView, setPrivacyView] = useState<boolean>(
    Cookies.get('PLAYTEST_PRIVACY_POLICY_VIEWED') === 'true'
  );
  const [privacyAnalytics, setPrivacyAnalytics] = useState<boolean>(
    Cookies.get('PLAYTEST_PRIVACY_AA_OPTOUT') === 'true'
  );

  useEffect(() => {
    toggleModal(!privacyView || props.open);
  }, [privacyView, props.open]);

  const onAccept = () => {
    setPrivacyView(true);
    setPrivacyAnalytics(true);
    if (props.open) props.onClose();

    Cookies.set('PLAYTEST_PRIVACY_POLICY_VIEWED', 'true', {
      expires: cookiesExpirationDay
    });
    Cookies.set('PLAYTEST_PRIVACY_AA_OPTOUT', 'true', {
      expires: cookiesExpirationDay
    });
  };

  const onReject = () => {
    setPrivacyView(true);
    setPrivacyAnalytics(false);
    if (props.open) props.onClose();

    Cookies.set('PLAYTEST_PRIVACY_POLICY_VIEWED', 'true', {
      expires: cookiesExpirationDay
    });
    Cookies.set('PLAYTEST_PRIVACY_AA_OPTOUT', 'false', {
      expires: cookiesExpirationDay
    });
  };

  const onSave = () => {
    setPrivacyView(true);
    if (props.open) props.onClose();
    toggleSettings(false);

    Cookies.set('PLAYTEST_PRIVACY_POLICY_VIEWED', 'true', {
      expires: cookiesExpirationDay
    });
    Cookies.set(
      'PLAYTEST_PRIVACY_AA_OPTOUT',
      privacyAnalytics ? 'true' : 'false',
      { expires: cookiesExpirationDay }
    );
  };

  return (
    <Modal
      className="modal-cookies"
      show={showModal}
      backdrop="static"
      size="xl"
    >
      <Modal.Header />
      <ModalBody>
        {settingsToggle ? (
          <>
            <div className="wrapper-return">
              <BsArrowLeft onClick={toggleSettings} />
              <h3>{intl.formatMessage({ ...message.settings })}</h3>
            </div>
            <p>{intl.formatMessage({ ...message.settingsBody })}</p>
            <div className="modal-cookies-settings">
              <div className="btn-on-off">
                <div className="btn-on-off-label-container">
                  <h4>{intl.formatMessage({ ...message.essential })}</h4>
                  <p className="label">
                    {intl.formatMessage({ ...message.essentialBody })}
                  </p>
                </div>
                <div className="ms-auto">
                  <ToggleButtonGroup
                    type="radio"
                    name="essentialCookies"
                    value={'true'}
                    defaultValue={'true'}
                  >
                    <ToggleButton
                      id="tbg-radio-1"
                      key="essentialCookiesOn"
                      value={'true'}
                    >
                      {intl.formatMessage({ ...message.buttonOn })}
                    </ToggleButton>
                    <ToggleButton
                      id="tbg-radio-2"
                      key="essentialCookiesOff"
                      value={'false'}
                      disabled
                    >
                      {intl.formatMessage({ ...message.buttonOff })}
                    </ToggleButton>
                  </ToggleButtonGroup>
                </div>
              </div>
              <div className="btn-on-off">
                <div className="btn-on-off-label-container">
                  <h4>{intl.formatMessage({ ...message.tracking })}</h4>
                  <p className="label">
                    {intl.formatMessage({ ...message.trackingBody })}
                  </p>
                </div>
                <div className="ms-auto">
                  <ToggleButtonGroup
                    type="radio"
                    name="trackingCookies"
                    value={privacyAnalytics ? 'true' : 'false'}
                  >
                    <ToggleButton
                      key="trackingCookiesOn"
                      value={'true'}
                      onClick={() => setPrivacyAnalytics(true)}
                    >
                      {intl.formatMessage({ ...message.buttonOn })}
                    </ToggleButton>
                    <ToggleButton
                      key="trackingCookiesOff"
                      value={'false'}
                      onClick={() => setPrivacyAnalytics(false)}
                    >
                      {intl.formatMessage({ ...message.buttonOff })}
                    </ToggleButton>
                  </ToggleButtonGroup>
                </div>
              </div>
            </div>
            <div className="wrapper-btn">
              <Button onClick={onSave}>
                {intl.formatMessage({ ...message.buttonSave })}
              </Button>
            </div>
          </>
        ) : (
          <>
            <h3>{intl.formatMessage({ ...message.welcome })}</h3>
            <p
              className="faq-body-response"
              dangerouslySetInnerHTML={{
                __html: intl.formatMessage({ ...message.welcomeBody })
              }}
            />
            <div className="wrapper-btn">
              <Button
                onClick={onReject}
                variant="secondary"
                className="btn-modal"
              >
                {intl.formatMessage({ ...message.buttonRefuse })}
              </Button>
              <Button
                onClick={toggleSettings}
                className="btn-secondary-outlined btn-modal"
              >
                {intl.formatMessage({ ...message.buttonSettings })}
              </Button>
              <Button onClick={onAccept} className="btn-modal">
                {intl.formatMessage({ ...message.buttonAccept })}
              </Button>
            </div>
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

export default TrackingModal;
